import axios from "axios";

const getCep = async (cepValue) => {
    let cepFiltrado = cepValue.replace(/\D/gm, '')
    if(cepFiltrado.length != 8)
        return null;
    let dadosRetorno = await axios({
    method: "get",
    url: `https://viacep.com.br/ws/${cepFiltrado}/json/`,
    })
    .then((response) => {
        return {
            nomeCidade: response.data.localidade,
            ufSigla: response.data.uf,
            logradouro: response.data.logradouro,
            bairro: response.data.bairro,
        };
    })
    .catch(() => {
    });

    return dadosRetorno;
}

export const CepService = {
    getCep
}

